import { createFileRoute } from '@tanstack/react-router'
import { ErrorBoundary } from 'react-error-boundary'
import { AccessControlUpsell, BotAccessControl } from '~/features/bots/components/settings'
import { isApiError } from '@botpress/client'
import { EmptyState } from '~/elements'
import ErrorIcon from '~/assets/website-maintenance-15.svg?react'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/settings/access-control')({
  component: Component,
})

function Component() {
  const { botId, workspaceId } = Route.useParams()
  const { user: currentUser } = Route.useRouteContext()
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        if (isApiError(error) && error.code === 403) {
          return <AccessControlUpsell workspaceId={workspaceId} />
        }

        return (
          <div className="mx-auto flex h-full w-full max-w-lg">
            <EmptyState
              iconSize={6}
              icon={ErrorIcon}
              title={'Something went wrong'}
              description={error?.message || 'Failed to load access control settings.'}
            />
          </div>
        )
      }}
    >
      <BotAccessControl workspaceId={workspaceId} botId={botId} currentUser={currentUser} />
    </ErrorBoundary>
  )
}
